<template>
  <section>
    <HeroSection headName="Cadastro de Contato" :searchBar="false" :addButton="false">
    </HeroSection>

    <div class="container">

      <form class="form">
        <div class="form__box" v-if="loading">
          <h2 class="form__name">
            <DataLoading rows="1" height="50px" />
          </h2>

          <div class="form__content">
            <DataLoading rows="4" height="80px" />
          </div>
        </div>

        <div class="form__wrap" v-if="!loading">
          <div class="form__box" v-if="isUserAdmin()">
            <h2 class="form__name">
              Dados do Utilizador
            </h2>

            <div class="form__content">
              <div class="form__row">
                <FormSearch label="Pesquisar Utilizador" v-model:modelValue="searcher" v-model:modelItem="sender" :dataList="senderListData" />
              </div>

              <div class="form__row">
                <FormInput label="Nome de Utilizador" :required="true" v-model:modelValue="model.sender.senderName" width="50%"/>

                <FormInput label="E-mail do Utilizador" :required="true" v-model:modelValue="model.sender.senderReplyToEmail" width="50%"/>
              </div>
            </div>
          </div>

          <div class="form__box">
            <h2 class="form__name">
              Dados do Contato
            </h2>

            <div class="form__content">
              <div class="form__row">
                <FormInput label="Nome do Contato" :required="true" v-model:modelValue="model.contactName"/>
              </div>

              <div class="form__row">
                <FormInput label="E-mail de Contato" :required="true" v-model:modelValue="model.contactEmail"/>
              </div>

              <div class="form__row form__row--nowrap">
                <FormCheckbox label="Ativo" :required="true" v-model:modelValue="model.contactIsActive" />
              </div>
            </div>
          </div>

          <FormBottom :data="button" @submit="submit()" />

        </div>
      </form>
    </div>
  </section>
</template>

<script>

import HeroSection from '@components/_partials/HeroSection.vue';
import DataLoading from '@components/_partials/DataLoading.vue';
import FormInput from '@components/_form/FormInput.vue';
import FormCheckbox from '@components/_form/FormCheckbox.vue';
import FormSearch from '@components/_form/FormSearch.vue';
import FormBottom from '@components/_form/FormBottom.vue';
import { baseUrl, padVal, brDate, docMask, phoneMask, brMoney, globalDate } from '@helpers/functions';
import { typeServices, schedulePeriod, isActive } from '@helpers/constants'
import contato from '@services/contato';
import usuario from '@services/usuario';
import storage from '@/config/storage';

export default {
  components: {
    HeroSection,
    DataLoading,
    FormInput,
    FormCheckbox,
    FormSearch,
    FormBottom
  },
  data() {
    return {
      loading: false,
      button: { spinner: false, label: 'Salvar Contato', color: 'primary' },
      model: { sender: {}, contactIsActive: true },
      senderListData: [],
      sender: {},
      dataList: [],
      pagination: {},
      searcher: '',
      search: '',
      isCpf: true,
      helpers: {
        cpf: '',
        cnpj: ''
      }
    }
  },
  methods: {
    baseUrl,
    brDate,
    padVal,
    docMask,
    phoneMask,
    brMoney,
    globalDate,
    typeServices,
    schedulePeriod,
    isActive,
    loadForm: function(_id) {
      const _this = this;
      _this.loading = true;

      contato.show(_id).then((res) => {
        if(typeof res !== 'undefined' && res.success) {
          _this.model = res.data;
          _this.sender = res.data.sender;
          _this.loading = false;
        }
      });
    },
    submit() {
      const _this = this;
      const _id = _this.hasIdx();
      const button = _this.button;

      let data = _this.model;

      _this.button = {
        spinner: true,
        label: 'Salvando...',
        color: 'warning'
      }
      contato.save(_id, data).then((res) => {
        if(typeof res !== 'undefined' && res.success) {
          _this.button = {
            spinner: false,
            label: 'Salvo com sucesso!',
            color: 'success'
          }

          setTimeout(() => this.$router.push('/contatos'), 1000);
        }

        if(typeof res === 'undefined' || !res.success) {
          _this.button = {
            spinner: false,
            label: 'Houve um erro ao processar.',
            color: 'danger'
          }
          setTimeout(() => _this.button = button, 3000);
        }
      })

    },
    hasIdx() {
      const _this = this;
      return _this.$route.params.id ? _this.$route.params.id : null;
    },
    isUserAdmin() {
      const local = 'mail4fly--user';
      const user = storage.get(local);
      return user && user.role === 'admin' ? true : false;
    },
  },
  watch: {
    '$route.params.page'(paged) {
     this.initLoad(paged);
    },
    'searcher'(search) {
      const _this = this;
      if(search && search.length > 3) {
        usuario.retrieve({ search }).then((res) => {
        if(typeof res !== 'undefined' && res.success) {
          const { docs } = res.data;
          _this.senderListData = docs;
        }
      });
      }

      if(!search || search.length == 0) {
        _this.senderListData = [];
      }
    },
    'sender'(sender) {
      const _this = this;
      const { _id, senderName, senderReplyToEmail  } = sender;

      _this.model.sender = { _id, senderName, senderReplyToEmail };
      _this.model.senderId = _id;
      _this.model.senderName = senderName;
      _this.senderListData = [];
      _this.searcher = '';
    }
  },
  mounted(){
    const _id = this.hasIdx();
    if(_id) this.loadForm(_id);
  }
};

</script>
